module.exports = __webpack_public_path__ + "static/media/info_3.b1919d23.svg";